import React, { useEffect } from "react";
import { ITkFakeTableLineProps } from "../../../type/componentsType/TkFakeTableLine";
import { Box, Typography } from "@mui/material";
import "./_style.scss";
import { TkRequiredText } from "../TkRequiredText";
import TkHelpIcon from "../TkHelpIcon";
import TkLabelText from "../TkLabelText";
import TkSuperPowerText from "../../molecules/TkSuperPowerText";
import TkAddressSearchByPostalCode from "../../molecules/TkAddressSearchByPostalCode";
import { TkRadioGroup } from "../TkRadioGroup";
import { TkSelectForm } from "../TkSelectForm";
import TkLocationGroup from "../../molecules/TkLocationGorup";
import TkFacilitySelection from "../../molecules/TkFacilitySelection";
import TkDatePicker from "../TkDatePicker";
import TkFileUpload from "../../molecules/TkFileUpload";
import { TkTransferCodeText } from "../TkTransferCodeText";
import TkEmailInput from "../../molecules/TkEmailInput";
import TkTextArea from "../../molecules/TkTextArea";
import TkInputWithText from "../../molecules/TkInputWithText";
import TkDownloadLink from "../TkDownloadLink";
import TkDurationPicker from "../../molecules/TkDurationPicker";
import TkInfoManual from "../TkInfoManual";
import TkMultipleLinesWithBorder from "../TkMultipleLinesWithBorder";
import BankButtonForFakeTableLine from "./components/bankButtonForFakeTableLine";
import TkContractorAndNumberLine from "../../molecules/TkContractorAndNumberLine";
import CheckBoxGroupForFakeTableLine from "./components/checkBoxGroupForFakeTableLine";
import LimitInputGroup from "./components/limitInputGroupForFakeTableLine";
import TkAmountInput from "../../molecules/TkAmountInput";
import RadioWithTextArea from "./components/radioWithTextArea";

const boxClassName = "tkFakeTableLineLabel";

/**
 * 画面基本構成部品（行）
 * 画面で使用するテーブルのレイアウト
 * @param {string} title 行のタイトル
 * @param text type = "text"の場合の表示テキスト
 * @param {string} lineTitle テーブルの説明文
 * @param {boolean} showLine 行の表示/非表示
 * @param {any} node 部品
 * @param {string} keyword 行のname
 * @param {string} type フィールドのタイプ
 * @param {boolean} helpicon ヘルプアイコンの表示有無
 * @param {string} helpText ヘルプアイコンのテキスト
 * @param {boolean} requiredIcon 必須マークの表示有無
 * @param {Array} errorsList エラー
 * @param {any} getPostalCodeError 郵便番号住所検索の返り値（エラー）
 * @param {any} getPostalCodeValue 郵便番号住所検索の返り値
 * @param {Array} radioPropsList ラジオグループの選択項目リスト
 * @param {Array} selectPropsList プルダウンの選択項目リスト
 * @param {boolean} isGuideMessage ラジオボタン押下時のガイドメッセージの表示有無
 * @param {string} guideMessage ラジオボタン押下時に表示するガイドメッセージ
 * @param {Array} valueObject 住所入力フォームに表示する値
 * @param isSCRC030001 施設選択部品の出し分けに使うフラグ
 * @param {any} setDefaultValue フィールドのデフォルト値
 * @param {any} inputProps 入力フォーマットのカスタム
 * @param {string} isShowInput 引継ぎコード入力欄部品のテキストボックス表示/非表示
 * @param {any} getTransferCode 引継ぎコード
 * @param explan
 * @param isShowexplan
 * @return TkFakeTableLine 画面基本構成部品（行）
 */
export const TkFakeTableLine: React.FC<ITkFakeTableLineProps> =
  React.forwardRef((props, ref) => {
    const {
      title,
      text,
      lineTitle,
      showLine = true,
      node,
      keyword,
      explanatoryText = "",
      explanatoryTextRule,
      type = "label",
      helpicon = false,
      helpText = "",
      requiredIcon = false,
      errorsList,
      getPostalCodeError,
      getPostalCodeValue,
      radioPropsList,
      selectPropsList,
      onClick,
      onChange,
      disabled = false,
      isGuideMessage = false,
      guideMessage = "",
      hafWidth = false,
      valueObject,
      disabledPrefectures,
      disabledCity,
      disabledAddress,
      isSCRC030001,
      setDefaultValue,
      inputProps,
      isShowInput,
      getTransferCode,
      explan,
      isShowexplan,
      base64filedata,
      dataname,
      getFacilityList,
      isResisterApplyFlg,
      showYears,
      round,
      start,
      end,
      onGetValue,
      dataList = [],
      hideButton,
      buttonName,
      isButton,
      buttonDisabled,
      onSuccessfulWithBank,
      bankSelButtonName,
      onGetInputValue,
      innerText,
      outerTextLeft,
      outerTextRight,
      contractorName,
      contractorNumber,
      isDaikou,
      onGoToKaiGai,
      fullWidth = true,
      requiredText,
      minDate,
      maxDate,
      checkBoxList,
      disabledMax,
      disabledMin,
      linkName,
      linkDisabled,
      maxLength,
      typeForLabelText,
      onlyNumber,
      downloadBase64,
      showLimit,
      rows,
      explanatoryInTitle = "",
      isSchool = false,
      ...rest
    } = props;

    const [errorMsg, setErrorMsg] = React.useState("");

    useEffect(() => {
      if (keyword) {
        if (errorsList[keyword]) setErrorMsg(errorsList[keyword].message || "");
        else setErrorMsg("");
      } else {
        setErrorMsg("");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(errorsList), keyword]);

    const typeMap: Record<string, React.ReactNode> = {
      // テキスト
      text: <Typography>{text}</Typography>,

      // React要素（行以外）
      node: <Box className="tkFakeTableLineNodeBox">{node}</Box>,

      // 行内React要素
      nodeInLine: <Box className="tkFakeTalbeLineNodeInLine">{node}</Box>,

      // 行タイトル
      lineTitle: <Box className="tkFakeTableLineTitleText">{lineTitle}</Box>,

      // 法人名と番号
      contractorAndNumber: (
        <TkContractorAndNumberLine
          name={contractorName ?? ""}
          no={contractorNumber ?? ""}
        ></TkContractorAndNumberLine>
      ),

      // 説明文
      explanatoryText: (
        <TkInfoManual
          rule={explanatoryTextRule}
          className="tkFakeTableLineExplanatoryText"
        >
          {explanatoryText}
        </TkInfoManual>
      ),

      // 上限と下限の入力制限
      limitInputGroup: (
        <LimitInputGroup
          error={!!errorMsg}
          errorMessage={errorMsg}
          onChange={onChange}
          wantToSetValue={setDefaultValue}
          disabledMax={disabledMax}
          disabledMin={disabledMin}
          {...rest}
        />
      ),

      // 金額入力
      amount: (
        <TkAmountInput
          error={!!errorMsg}
          errorMessage={errorMsg}
          wantToSetValue={setDefaultValue}
          inputProps={inputProps}
          disabled={disabled}
          onChange={onChange}
          onGetInputValue={onGetInputValue}
          innerText={innerText}
          {...rest}
        />
      ),

      // テキストエリア
      label: (
        <TkLabelText
          fullWidth={fullWidth}
          error={!!errorMsg}
          helperText={errorMsg}
          onChange={onChange}
          onGetInputValue={onGetInputValue}
          disabled={disabled}
          wantToSetValue={setDefaultValue}
          inputProps={inputProps}
          type={typeForLabelText}
          {...rest}
        />
      ),

      // テキストエリア（名前）
      name: (
        <TkSuperPowerText
          error={!!errorMsg}
          helperText={errorMsg}
          onGetInputValue={onGetInputValue}
          type="name"
          onChange={onChange}
          disabled={disabled}
          inputProps={inputProps}
          hafWidth={hafWidth}
          wantToSetValue={setDefaultValue}
          {...rest}
        />
      ),

      // テキストエリア（電話番号）
      phoneNum: (
        <TkSuperPowerText
          error={!!errorMsg}
          helperText={errorMsg}
          onGetInputValue={onGetInputValue}
          type="phoneNum"
          onChange={onChange}
          disabled={disabled}
          inputProps={inputProps}
          wantToSetValue={setDefaultValue}
          {...rest}
        />
      ),

      // テキストエリア（郵便番号）
      postcode: (
        <TkSuperPowerText
          error={!!errorMsg}
          helperText={errorMsg}
          onGetInputValue={onGetInputValue}
          type="postcode"
          onChange={onChange}
          disabled={disabled}
          inputProps={inputProps}
          wantToSetValue={setDefaultValue}
          {...rest}
        />
      ),

      // 住所検索
      addressSearch: (
        <TkAddressSearchByPostalCode
          error={!!errorMsg}
          helperText={errorMsg}
          getError={getPostalCodeError}
          getPostalCodeValue={getPostalCodeValue}
          onGetValue={onGetValue}
          wantToSetValue={setDefaultValue}
          onChange={onChange}
          disabled={disabled}
          hideButton={hideButton}
          {...rest}
        />
      ),

      // ラジオボタン
      radio: (
        <TkRadioGroup
          errorMessage={errorMsg}
          radioPropsList={radioPropsList}
          onClick={onClick}
          onChange={onChange}
          onGetValue={onGetValue}
          disabled={disabled}
          isGuideMessage={isGuideMessage}
          guideMessage={guideMessage}
          wantToSetValue={setDefaultValue}
          {...rest}
        />
      ),

      // テキストエリア付きラジオボタン
      radioWithText: (
        <RadioWithTextArea
          onChange={onChange}
          onGetValue={onGetValue}
          radioPropsList={radioPropsList}
          wantToSetValue={setDefaultValue}
          inputProps={inputProps}
          errorMessage={errorMsg}
          disabled={disabled}
        />
      ),

      // チェックボックス
      checkboxGroup: (
        <CheckBoxGroupForFakeTableLine
          checkBoxList={checkBoxList}
          error={!!errorMsg}
          errorMessage={errorMsg}
          onChange={onChange}
          onGetValue={onGetValue}
          wantToSetValue={setDefaultValue}
          {...rest}
        />
      ),

      // プルダウン
      selectForm: (
        <TkSelectForm
          error={!!errorMsg}
          errorMessage={errorMsg}
          selectPropsList={selectPropsList || []}
          onChange={onChange}
          onGetValue={onGetValue}
          fullWidth={fullWidth}
          disabled={disabled}
          wantToSetValue={setDefaultValue}
          guideMessage={guideMessage}
          isGuideMessage={isGuideMessage}
          {...rest}
        />
      ),

      // 都道府県、市区町村、その他
      locationGroup: (
        <TkLocationGroup
          error={!!errorMsg}
          errorMessage={errorMsg}
          valueObject={valueObject}
          setDefaultValue={setDefaultValue}
          onChange={onChange}
          disabled={disabled}
          disabledPrefectures={disabledPrefectures}
          disabledCity={disabledCity}
          disabledAddress={disabledAddress}
          inputProps={inputProps}
          {...rest}
        />
      ),

      // ファイルアップロード
      fileUpload: (
        <TkFileUpload
          error={!!errorMsg}
          errorMsg={errorMsg}
          onChange={onChange}
          wantToSetValue={setDefaultValue}
          disabled={disabled}
          onGetValues={onGetValue}
          {...rest}
          id={rest.id}
        />
      ),

      // 日付選択
      date: (
        <TkDatePicker
          error={!!errorMsg}
          errorMessage={errorMsg}
          disabled={disabled}
          onChange={onChange}
          wantToSetValue={setDefaultValue}
          minDate={minDate}
          maxDate={maxDate}
          onGetInputValue={onGetInputValue}
          {...rest}
        />
      ),

      // 施設種類選択
      facilityType: (
        <TkFacilitySelection
          isSCRC030001={isSCRC030001}
          error={!!errorMsg}
          errorMessage={errorMsg}
          onChange={onChange}
          disabled={disabled}
          wantToSetValue={setDefaultValue}
          getFacilityList={getFacilityList}
          isResisterApplyFlg={isResisterApplyFlg}
          {...rest}
        />
      ),

      // 引継ぎコード
      transferCodeText: (
        <TkTransferCodeText
          onChange={onChange}
          disabled={disabled}
          isSchool={isSchool}
          wantToSetValue={setDefaultValue}
          onSuccess={getTransferCode}
          onGetValue={onGetValue}
          {...rest}
        />
      ),

      // 文字改行（赤字）
      textWithExplanation: (
        <Typography>
          {text}
          <br />
          <label
            style={{
              color: "red",
              fontSize: "small",
              display: isShowexplan ? "" : "none",
            }}
          >
            {explan}
          </label>
        </Typography>
      ),

      // メールアドレス
      mail: (
        <TkEmailInput
          helperText={errorMsg}
          wantToSetValue={setDefaultValue}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        ></TkEmailInput>
      ),

      // テキストエリア
      textarea: (
        <TkTextArea
          fullWidth
          error={!!errorMsg}
          helperText={errorMsg}
          disabled={disabled}
          onChange={onChange}
          onGetInputValue={onGetInputValue}
          inputProps={inputProps}
          wantToSetValue={setDefaultValue}
          showLimt={showLimit}
          rows={rows}
          {...rest}
        />
      ),

      // 前後文字がついているテキストエリア
      inputWithText: (
        <TkInputWithText
          error={!!errorMsg}
          helperText={errorMsg}
          disabled={disabled}
          onChange={onChange}
          inputProps={inputProps}
          wantToSetValue={setDefaultValue}
          innerText={innerText}
          outerTextLeft={outerTextLeft}
          outerTextRight={outerTextRight}
          onGetInputValue={onGetInputValue}
          onlyNumber={onlyNumber}
          {...rest}
        />
      ),

      // ファイルダウンロード
      downloadLink: (
        <TkDownloadLink
          dataname={dataname ? dataname : ""}
          base64filedata={base64filedata ? base64filedata : ""}
          isButton={isButton}
          buttonDisabled={buttonDisabled}
          buttonName={buttonName}
          linkName={linkName}
          linkDisabled={linkDisabled}
          downloadBase64={downloadBase64}
          onClick={onClick}
        />
      ),

      // 期間選択
      durationPicker: (
        <TkDurationPicker
          onGetInputValue={onGetInputValue}
          start={start}
          end={end}
          showYears={showYears}
          round={round}
          minDate={minDate}
          maxDate={maxDate}
          error={!!errorMsg}
          errorMsg={errorMsg}
          onChange={onChange}
          {...rest}
        />
      ),

      // 複数行テキスト
      multipleLinesWithBorder: (
        <TkMultipleLinesWithBorder
          className="TkMultipleLinesWithBorderInFakeTableLine"
          dataList={dataList}
        />
      ),

      // 金融機関検索
      bankSearch: (
        <BankButtonForFakeTableLine
          error={!!errorMsg}
          errorMessage={errorMsg}
          bankSelButtonName={bankSelButtonName}
          onSuccessfulWithBank={onSuccessfulWithBank}
          onChange={onChange}
          isDaikou={isDaikou}
          onGoToKaiGai={onGoToKaiGai}
          wantToSetValue={setDefaultValue}
          buttonDisabled={buttonDisabled}
          {...rest}
        />
      ),
    };
    const labelContent = typeMap[type];

    const renderCompent = () => {
      let resCom = <></>;

      if (type === "lineTitle" || type === "explanatoryText") {
        resCom = <Box className={boxClassName}>{labelContent}</Box>;
      } else if (type === "node" || type === "contractorAndNumber") {
        resCom = <>{labelContent}</>;
      } else {
        resCom = (
          <Box className="tkFakeTableLineMain">
            <Box className="tkFakeTableLineTitle">
              <Box className="tkFakeTableLineTitleTop">
                {title}
                {requiredIcon && <TkRequiredText requiredText={requiredText} />}
                {helpicon && <TkHelpIcon helpMessage={helpText} />}
              </Box>

              {explanatoryInTitle && (
                <Box className="tkExplanatoryInTitle">{explanatoryInTitle}</Box>
              )}
            </Box>

            <Box className={boxClassName}>{labelContent}</Box>
          </Box>
        );
      }

      return resCom;
    };

    return (
      <Box className={`tkFakeTableLine ${!showLine ? "hide" : ""}`}>
        {renderCompent()}
      </Box>
    );
  });

export default TkFakeTableLine;
